export default {
  data() {
    return {
      models: [
        { header: 'Master files' },
        {
          value: 'client',
          text: 'Client',
          nameField: 'name',
          icon: 'client',
          type: 'master'
        },
        {
          value: 'project',
          text: 'Project',
          nameField: 'name',
          icon: 'project',
          type: 'master'
        },
        {
          value: 'site',
          text: 'Site',
          nameField: 'siteName_projectName',
          icon: 'site',
          type: 'master'
        },
        {
          value: 'tip',
          text: 'Tip',
          nameField: 'name',
          icon: 'tip',
          type: 'master'
        },
        {
          value: 'spoil',
          text: 'Spoil',
          nameField: 'name',
          icon: 'spoil',
          type: 'master'
        },
        {
          value: 'contractor',
          text: 'Contractor',
          nameField: 'name',
          icon: 'contractor',
          type: 'master'
        },
        {
          value: 'vehicle',
          text: 'Vehicle',
          nameField: 'vehicleName_vehicleType_contractorName',
          icon: 'vehicle',
          type: 'master'
        },
        {
          value: 'driver',
          text: 'Driver',
          nameField: 'driverName_contractorName',
          icon: 'driver',
          type: 'master'
        },
        {
          value: 'rate',
          text: 'Rate',
          nameField: 'id',
          icon: 'rate',
          type: 'transaction'
        },
        { divider: true },
        { header: 'Transaction files' },
        {
          value: 'allocation',
          text: 'Allocation',
          nameField: 'id',
          icon: 'allocation',
          type: 'transaction'
        },
        {
          value: 'allocationBatchHeader',
          text: 'Allocation Batch Header',
          nameField: 'id',
          icon: 'allocation',
          type: 'transaction'
        },
        {
          value: 'allocationBatchLine',
          text: 'Allocation Batch Line',
          nameField: 'id',
          icon: 'allocation',
          type: 'transaction'
        },
        {
          value: 'docket',
          text: 'Docket',
          nameField: 'id',
          icon: 'docket',
          type: 'transaction'
        },
        {
          value: 'trip',
          text: 'Trip',
          nameField: 'id',
          icon: 'docket',
          type: 'transaction'
        },
        {
          value: 'rcti',
          text: 'RCTI',
          nameField: 'id',
          icon: 'rcti',
          type: 'transaction'
        },
        {
          value: 'bill',
          text: 'Bill',
          nameField: 'id',
          icon: 'billing',
          type: 'transaction'
        },
        {
          value: 'tippingDocketHeader',
          text: 'Tipping Docket Header',
          nameField: 'id',
          icon: 'tipping',
          type: 'transaction'
        },
        {
          value: 'tippingDocketLine',
          text: 'Tipping Docket Line',
          nameField: 'id',
          icon: 'tipping',
          type: 'transaction'
        },
        {
          value: 'complianceResource',
          text: 'Compliance Resource',
          nameField: 'id',
          icon: 'compliance',
          type: 'transaction'
        }
      ]
    }
  }
}
